
module.exports = require('./socket');

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = require('engine.io-parser');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_engine.io-client@3.3.2@engine.io-client/lib/index.js
// module id = xMg3
// module chunks = 0